<template>
  <div class="home_page">
    <el-header class="right-menu-name" height="20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">{{
          $t("route.myAccount")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="tabs">
      <div
        v-for="item in tabList"
        :key="item.key"
        :class="
          's2b-tab-item ' + (item.active ? 'tab-item-active' : '')
        "
        @click="changeStatusHandle(item.key)"
      >
        {{ item.lable }}
      </div>
    </div>
    <div class="shopping-cart" v-show="activited !== '5' && activited !== '6'">
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; max-width: 100%"
        height="calc(100vh - 274px)"
        row-key="goodsSkuId"
      >
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
          :selectable="checkSelectable"
        ></el-table-column>
        <el-table-column
          prop="img"
          label="商品信息"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="detail">
              <el-image
                :src="scope.row.fileUrls"
                class="goodsImg"
                :preview-src-list="[scope.row.fileUrls]"
              >
                <div slot="error">
                  <img src="~@/assets/img/bitmap.png" class="goodsImg" />
                </div>
              </el-image>
              <div class="mask" v-if="!scope.row.used">未上架</div>
              <div class="info">
                <h3>
                  <a
                    href="javascript:;"
                    @click="goodDetail(scope.row)"
                    v-if="scope.row.used"
                    ><Tooltip :innerContent="scope.row.goodsName | isEmpty" /></a
                  >
                  <Tooltip v-else :innerContent="scope.row.goodsName | isEmpty" />
                </h3>
                <span>型号：{{ scope.row.model | isEmpty }}</span>
                <span>规格：{{ scope.row.specification | isEmpty }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('cart.columnCode')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.skuCode || scope.row.oldGoodsCode }}
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('cart.columnBrand')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.brandName | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sellingUnit"
          :label="$t('cart.column4')"
          v-if="activited === '4' || activited === '1'"
          header-align="center"
          align="center"
          width="60"
        >
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('cart.column5')"
          header-align="center"
          align="center"
          width="175"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.used">
              <el-tooltip
                placement="top"
                :content="`起订量${scope.row.moq || 1}, 步长${
                  scope.row.sellingUnitStepSize || 1
                }`"
              >
                <span>
                  <el-input-number
                    v-model="scope.row.goodsNum"
                    @change="
                      (currentValue, oldValue) =>
                        changeAmount(
                          currentValue,
                          oldValue,

                          scope.row,
                          scope.$index
                        )
                    "
                    :min="1"
                    :max="999999999"
                    :step="scope.row.sellingUnitStepSize || 1"
                    :precision="0"
                    size="small"
                  ></el-input-number>
                </span>
              </el-tooltip>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="model"
          :label="$t('cart.column6')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.used">
              <div
                v-if="
                  scope.row.activityType &&
                  (scope.row.activityType == 1 || scope.row.activityType == 2)
                "
              >
                <span v-if="activited === '4'">
                  {{ $t("common.currency")}}{{(scope.row.activityPrice * scope.row.goodsNum)| formatePrice4}}
                </span>
                <span v-else>
                  {{ $t("common.currency")}}{{(scope.row.activityPrice * scope.row.goodsNum)| formatePrice}}
                </span>
                <br />
              </div>
              <div v-else>
                <span v-if="activited === '4'">
                  {{ $t("common.currency")}}{{(scope.row.sellingPrice * scope.row.goodsNum) | formatePrice4}}
                </span>
                <span v-else>
                  {{ $t("common.currency")}}{{(scope.row.sellingPrice * scope.row.goodsNum) | formatePrice}}
                </span>
              </div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('handle')"
          header-align="center"
          align="center"
          width="60"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandle(scope.row)">{{
              $t("delete")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fix">
        <div class="left">
          <el-checkbox
            v-model="allCheck"
            class="check-all"
            :disabled="!dataList.length || dataListLoading"
            @change="handleCheckAllChange"
            >{{ $t("common.checkAll") }}</el-checkbox
          >
          <el-button
            type="text"
            @click="handleDeleteChoosed()"
            :disabled="dataListLoading"
          >
            {{ $t("cart.removeSeleted") }}
          </el-button>
          <el-button
            type="text"
            @click="clearUseless()"
            :disabled="dataListLoading"
          >
            删除未上架商品
          </el-button>
          <el-button
            type="text"
            @click="clearShoppingCart()"
            :disabled="dataListLoading"
          >
            {{ $t("cart.clearCart") }}
          </el-button>
        </div>
        <div class="fix-right">
          <div class="div1">
            {{ $t("cart.itemsSelected") }}
            <span class="red">&nbsp;{{ selectGoods }}&nbsp;</span>
            <!-- 件商品 -->
          </div>
          <div class="div2" v-show="activited !== '3'">
            <span
              >{{ $t("cart.totalPrice") }}：{{ $t("common.currency")
              }}
              <span v-if="activited === '4'" class="red">{{ allMoney | formatePrice4 }}</span>
              <span v-else class="red">{{ allMoney | formatePrice }}</span>
            </span><br />
            <span class="discount">
              <!-- 原价： -->
              <span v-if="activited === '4'">{{ $t("common.currency")
                }}{{ allDiscount | formatePrice4 }}
              </span>
              <span v-else>{{ $t("common.currency")
                }}{{ allDiscount | formatePrice }}
              </span>
            </span>
          </div>
          <el-button
            class="div3"
            type="primary"
            :class="{ buttonDemand: activited === '3' }"
            plain
            :disabled="!dataList.length || dataListLoading"
            v-show="activited !== '3'"
            @click="settlement"
          >
            {{
              activited === "1"
                ? $t("cart.settle")
                : activited === "3"
                ? $t("cart.settle2")
                : $t("cart.settle3")
            }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 选型 -->
    <div class="shopping-cart" v-show="activited === '6'">
      <el-table
        v-loading="lectotypeListLoading"
        :data="lectotypeList"
        ref="lectotypeTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; max-width: 100%"
        height="800px"
      >
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
          :selectable="checkSelectable"
        ></el-table-column>
        <el-table-column
          prop="img"
          label="商品信息"
          header-align="center"
          align="center"
          minWidth="120"
        >
          <template slot-scope="scope">
            <div class="detail">
              <el-image
                :src="scope.row.fileUrl"
                class="goodsImg"
                :preview-src-list="[scope.row.fileUrl]"
              >
                <div slot="error">
                  <img src="~@/assets/img/bitmap.png" class="goodsImg" />
                </div>
              </el-image>
              <div class="mask" v-if="!scope.row.used">未上架</div>
              <div class="info">
                <h3>
                  <a
                    href="javascript:;"
                    @click="goodDetail(scope.row)"
                    v-if="scope.row.used"
                    ><Tooltip :innerContent="scope.row.name | isEmpty"
                  /></a>
                  <Tooltip v-else :innerContent="scope.row.name | isEmpty" />
                </h3>
                <Tooltip :innerContent="`${$t('product.supplyCommodityCode')}：${scope.row.supplyCommodityCode || '-'}`" />
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="model"
          :label="$t('cart.columnCode')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.skuCode || scope.row.oldGoodsCode }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="model"
          :label="$t('cart.columnBrand')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.brandName | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="seriesName"
          :label="$t('common.collection')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.seriesName | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('common.model')"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.model | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="attributeInfoList"
          header-align="center"
          align="center"
          label="详细参数"
          min-width="150"
        >
          <template slot-scope="scope">
            <!-- <span v-for="(attrItem,attrIndex) in scope.row.attributeInfoList" :key="attrIndex">
              {{attrItem.attributeItemName}}：{{attrItem.attributeValueName}}
            </span> -->
            {{ filterAttribute(scope.row.attributeInfoList) || "-" }}
            <InfoIcon
              v-if="
                scope.row.attributeInfoList &&
                scope.row.attributeInfoList.length &&
                scope.row.attributeInfoList.length > 1
              "
              :row="scope.row.attributeInfoList"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="deliveryTime"
          label="供货周期(工作日)"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.deliveryTime | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('cart.column5')"
          header-align="center"
          align="center"
          width="175"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.used">
              <el-tooltip
                placement="top"
                :content="`起订量${scope.row.moq || 1}, 步长${
                  scope.row.sellingUnitStepSize || 1
                }`"
              >
                <span>
                  <el-input-number
                    v-model="scope.row.goodsNum"
                    @change="
                      (currentValue, oldValue) =>
                        changeAmount(
                          currentValue,
                          oldValue,
                          scope.row,
                          scope.$index
                        )
                    "
                    :min="1"
                    :max="999999999"
                    :step="scope.row.sellingUnitStepSize || 1"
                    :precision="0"
                    size="small"
                  ></el-input-number>
                </span>
              </el-tooltip>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('handle')"
          header-align="center"
          align="center"
          width="60"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandle(scope.row)">{{
              $t("delete")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fix">
        <div class="left">
          <el-checkbox
            v-model="allCheck"
            class="check-all"
            :disabled="!lectotypeList.length || lectotypeListLoading"
            @change="handleCheckAllChange"
            >{{ $t("common.checkAll") }}</el-checkbox
          >
          <el-button
            type="text"
            @click="handleDeleteChoosed()"
            :disabled="lectotypeListLoading"
          >
            {{ $t("cart.removeSeleted") }}
          </el-button>
          <el-button
            type="text"
            @click="clearUseless()"
            :disabled="lectotypeListLoading"
          >
            删除未上架商品
          </el-button>
          <el-button
            type="text"
            @click="clearShoppingCart()"
            :disabled="lectotypeListLoading"
          >
            {{ $t("cart.clearCart") }}
          </el-button>
        </div>
        <div class="fix-right">
          <div class="div1">
            {{ $t("cart.itemsSelected") }}
            <span class="red">&nbsp;{{ selectLectotypeGoods }}&nbsp;</span>
            <!-- 件商品 -->
          </div>
          <el-button
            class="div3"
            type="primary"
            plain
            :disabled="!lectotypeList.length || lectotypeListLoading"
            @click="settlement"
          >
            {{ $t("cart.settle4") }}
          </el-button>
        </div>
      </div>
    </div>
    <company-add
      ref="companyAdd"
      v-if="addCompanyVisible"
      :jumpRoute="false"
    ></company-add>
  </div>
</template>
<script>
import Tooltip from '@/components/tooltipShow/index'
import { openOther } from '@/utils'
import CompanyAdd from '@/views/modules/personalCenter/organization/company-add'
import InfoIcon from '@/views/modules/selectionInquiry/components/infoIcon.vue'
export default {
  name: 'shopCart', // 购物车
  components: {
    CompanyAdd,
    InfoIcon,
    Tooltip
  },
  data () {
    return {
      dataList: [],
      expiredList: [], // 过期商品列表
      dataListLoading: false,
      multipleSelection: [], // 多选数组
      allCheck: false, // 全选
      activited: '6',
      lectotypeList: [], // 选型
      lectotypeListLoading: false,
      tabList: [
        {
          key: '1',
          lable: '询价单'
        },
        {
          key: '2',
          lable: '选型',
          active: true
        }
      ],
      addCompanyVisible: false, // 企业账号 dialog
      changeAble: false
    }
  },
  computed: {
    selectGoods () {
      let totalNum = 0
      this.multipleSelection.forEach((item) => {
        let row = this.dataList.find((shopItem) => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          totalNum += row.goodsNum
        }
      })
      return totalNum // Math.round(totalPrice * 10000) / 10000
    },
    selectLectotypeGoods () {
      let totalNum = 0
      this.multipleSelection.forEach((item) => {
        let row = this.lectotypeList.find((shopItem) => {
          return shopItem.id === item.id
        })
        if (row) {
          totalNum += row.goodsNum
        }
      })
      return totalNum // Math.round(totalPrice * 10000) / 10000
    },
    allMoney () {
      let totalMoney = 0
      this.multipleSelection.forEach((item) => {
        let row = this.dataList.find((shopItem) => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          if (
            row.activityType &&
            (row.activityType === 1 || row.activityType === 2)
          ) {
            totalMoney += row.activityPrice * row.goodsNum
          } else {
            totalMoney += row.sellingPrice * row.goodsNum
          }
        }
      })
      return Math.round(totalMoney * 10000) / 10000
    },
    allDiscount () {
      let totalMoney = 0
      this.multipleSelection.forEach((item) => {
        let row = this.dataList.find((shopItem) => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          totalMoney += row.sellingPrice * row.goodsNum
        }
      })
      return Math.round(totalMoney * 10000) / 10000
    }
  },
  mounted () {
    if (this.$route.query.activited) {
      this.activited = this.$route.query.activited
    }
    this.getLectotypeList()
    this.getDataList()
    this.getShopCartCount()
  },
  methods: {
    checkSelectable (row) {
      return row.used
    },
    // 修改步长
    changeAmount (currentValue, oldValue, val, index) {
      if (this.activited === '6') { // 选型
        this.handleChangeLectotypeCount(currentValue, oldValue, val, index)
      } else {
        this.handleChangeCount(currentValue, oldValue, val, index)
      }
    },
    changeStatusHandle (val) {
      if (val === '1') {
        this.$router.push({
          name: 'myInquiryCart'
        })
      } else {
        this.$router.push({
          name: 'lectotypeCart'
        })
      }
    },
    getLectotypeList () {
      this.lectotypeListLoading = true
      this.$http
        .post(`/front/commodity-user/web/lectotypeCart/list`)
        .then(({ data }) => {
          this.lectotypeList = data.data.dataList || []
        })
        .catch(() => {
          this.lectotypeList = []
        })
        .finally(() => {
          this.lectotypeListLoading = false
        })
    },
    // 获取购物车各个类型数量接口
    getShopCartCount () {
      this.tabList.forEach((item) => {
        item.count = 0
      })
      this.$request
        .get(`/front/consumer/shoppingcart/queryShoppingCartList`)
        .then((data) => {
          if (data) {
            this.tabList[1].count = data.ordinaryCount || 0
            this.tabList[0].count = data.sparePartCount || 0
            // this.tabList[2].count = data.trainCourseCount || 0
            this.tabList[2].count = data.lectotypeSpuCount || 0
          } else {
            this.tabList.forEach((item) => {
              item.count = 0
            })
          }
        })
        .catch(() => {
          this.tabList.forEach((item) => {
            item.count = 0
          })
        })
    },
    // 获取当前用户的购物车列表
    getDataList () {
      this.multipleSelection = []
      this.allCheck = false
      this.dataListLoading = true
      this.$request
        .get(
          `/front/consumer/shoppingcart/myShoppingCartList/${this.activited}`
        )
        .then((data) => {
          if (!data) {
            return
          }
          if (this.activited !== '5') {
            this.dataList = [
              ...(data.available || []),
              ...(data.unavailable || [])
            ]
          } else {
            this.dataList = data.available || []
            this.expiredList = data.unavailable || []
          }
        })
        .catch(() => {
          this.dataList = []
          this.expiredList = []
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    goodDetail (goods) {
      if (this.activited === '3' || this.activited === '4') {
        openOther(
          `sparePartsLibraryGoodDetail?spuId=${goods.goodsSpuId}&skuId=${goods.goodsSkuId}&custspId=${goods.custspId}`
        )
      } else if (this.activited === '5') {
        openOther(`courseDetail?id=${goods.goodsId}`)
      } else if (this.activited === '6') { // 选型
        openOther(`selectionInquiryDetail?spuId=${goods.spuId}`)
      } else {
        openOther(
          `goodDetail?spuId=${goods.goodsSpuId}&skuId=${goods.goodsSkuId}`
        )
      }
    },
    // 表格多选
    handleSelectionChange (val) {
      let dataList = this.dataList
      if (this.activited === '6') {
        dataList = this.lectotypeList
      }
      this.multipleSelection = val
      if (
        val.length &&
        val.length === dataList.filter((i) => i.used).length
      ) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
    },
    // 底部全选
    handleCheckAllChange (val) {
      let multipleTable = this.$refs.multipleTable
      if (this.activited === '6') {
        multipleTable = this.$refs.lectotypeTable
      }
      if (val) {
        multipleTable.toggleAllSelection()
      } else {
        multipleTable.clearSelection()
      }
    },
    // 更改购物车数量
    handleChangeCount (currentValue, oldValue, row, index) {
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http
        .post(`/front/consumer/shoppingcart/updateShoppingCart`, {
          shoppingCartId: row.shoppingCartId,
          goodsNum: currentValue
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.getDataList()
            return false
          } else {
            // this.$set(this.dataList, `${index}`, {
            //   ...this.dataList[index],
            //   goodsNum: currentValue
            // })
            this.dataList[index].goodsNum = currentValue
          }
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 更改'购物车-选型'数量
    handleChangeLectotypeCount (currentValue, oldValue, row, index) {
      if (this.lectotypeListLoading) {
        return false
      }
      this.lectotypeListLoading = true
      this.$http
        .post(`/front/commodity-user/web/lectotypeCart/update`, {
          id: row.id,
          goodsNum: currentValue
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.getLectotypeList()
            return false
          } else {
            this.$set(this.lectotypeList, `${index}`, {
              ...this.lectotypeList[index],
              goodsNum: currentValue
            })
          }
        })
        .finally(() => {
          this.lectotypeListLoading = false
        })
    },
    // 删除一行数据
    deleteHandle (row) {
      if (this.activited === '6') { // 选型
        this.deleteLectotypeCartGood([row.id])
      } else {
        this.deleteShoppingCartGood([row.shoppingCartId])
      }
    },
    // 删除已选中的商品
    handleDeleteChoosed () {
      if (this.activited === '6') { // 选型
        this.deleteLectotypeCartGood(
          this.multipleSelection.map((item) => {
            return item.id
          })
        )
      } else {
        this.deleteShoppingCartGood(
          this.multipleSelection.map((item) => {
            return item.shoppingCartId
          })
        )
      }
    },
    clearUseless () {
      if (this.activited === '6') { // 选型
        this.deleteLectotypeCartGood(
          this.lectotypeList
            .filter((i) => !i.used)
            .map((item) => {
              return item.id
            })
        )
      } else {
        this.deleteShoppingCartGood(
          this.dataList
            .filter((i) => !i.used)
            .map((item) => {
              return item.shoppingCartId
            })
        )
      }
    },
    // 清空购物车
    clearShoppingCart () {
      if (this.activited === '6') { // 选型
        this.deleteLectotypeCartGood(
          this.lectotypeList.map((item) => {
            return item.id
          })
        )
      } else {
        this.deleteShoppingCartGood(
          this.dataList.map((item) => {
            return item.shoppingCartId
          })
        )
      }
    },
    // 删除购物车信息
    deleteShoppingCartGood (ids = []) {
      if (ids.length === 0) {
        return this.$message.warning(this.$t('message.selectData2'))
      }
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http
        .post(`/front/consumer/shoppingcart/deleteShoppingCart`, ids)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          this.getDataList()
          this.getShopCartCount()
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 删除‘购物车-选型’信息
    deleteLectotypeCartGood (ids = []) {
      if (ids.length === 0) {
        return this.$message.warning(this.$t('message.selectData2'))
      }
      if (this.lectotypeListLoading) {
        return false
      }
      this.lectotypeListLoading = true
      this.$http
        .post(`/front/commodity-user/web/lectotypeCart/remove`, { ids })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          this.getLectotypeList()
          this.getShopCartCount()
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
        })
        .finally(() => {
          this.lectotypeListLoading = false
        })
    },
    // 结算 跳转订单页面
    settlement () {
      if (this.dataListLoading) {
        return
      }
      // this.multipleSelection.map(item => {
      //   return item.shoppingCartId
      // })
      if (!this.multipleSelection.length) {
        return this.$message.warning(this.$t('message.selectData'))
      }
      if (
        this.multipleSelection.some((item) => {
          const { sellingUnitStepSize, goodsNum, moq } = item
          const goodsName = item.goodsName || item.name
          const ret =
            goodsNum < (+moq || 1) ||
            goodsNum % (sellingUnitStepSize || 1) !== 0
          if (ret) {
            this.$message.warning(
              `【${goodsName}】起订量为${moq || 1}，步长为${
                sellingUnitStepSize || 1
              }，请输入大于${moq || 1}且${sellingUnitStepSize || 1}的倍数！`
            )
          }
          return ret
        })
      ) {
        return
      }

      let shoppingCartFormList = []
      this.multipleSelection.forEach((item) => {
        let dataList = this.dataList
        if (this.activited === '6') dataList = this.lectotypeList
        let row = dataList.find((ele) => {
          return ele.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          if (this.activited === '1') {
            shoppingCartFormList.push({
              goodsSpuId: item.goodsSpuId,
              goodsSkuId: item.goodsSkuId,
              goodsNum: item.goodsNum,
              sellingPrice: item.sellingPrice,
              moq: item.moq || null,
              sellingUnitStepSize: item.sellingUnitStepSize || null
            })
          } else if (this.activited === '3') {
            // 备件需求
            shoppingCartFormList.push({
              oldGoodsCode: item.skuCode,
              oldGoodsName: item.goodsName,
              oldSpecification: item.oldSpecification,
              oldModel: item.model,
              oldBrand: item.brandName,
              oldRemark: '',
              safetyStockQuantityBef: 0,
              sellingUnit: item.sellingUnit,
              safetyStockQuantity: item.goodsNum,
              physicalUnitAmount: item.physicalUnitAmount,
              moq: item.moq || null,
              sellingUnitStepSize: item.sellingUnitStepSize || null
            })
          } else if (this.activited === '4') {
            console.log('领用', item)
            // 领用
            shoppingCartFormList.push({
              // goodsCode: '',
              // goodsName: '',
              // specification: '',
              // model: '',
              // remark: '',
              // goodsUrl: item.fileUrls,
              // edition: '',
              // congiguration: '',
              oldGoodsCode: item.skuCode,
              oldGoodsName: item.goodsName,
              oldSpecification: item.oldSpecification,
              oldModel: item.model,
              oldBrand: item.brandName,
              oldRemark: item.oldRemark,
              goodsNum: item.goodsNum,
              oldEdition: item.oldEdition,
              sellingUnit: item.sellingUnit,
              oldCongiguration: item.oldCongiguration,
              price: item.sellingPrice,
              // price: item.activityPrice || item.sellingPrice,
              // safetyStockQuantityBef: 0,
              safetyStockQuantity: item.safetyStockQuantity,
              custspId: item.custspId,
              physicalUnitAmount: item.physicalUnitAmount,
              moq: item.moq || null,
              sellingUnitStepSize: item.sellingUnitStepSize || null,
              skuId: item.skuId || item.goodsSkuId
            })
          } else if (this.activited === '6') {
            // 选型
            shoppingCartFormList.push(item.id)
          }
        }
      })
      if (this.activited === '1') {
        if (shoppingCartFormList.length) {
          this.dataListLoading = true
          // 立即下单校验数量价格相关等
          this.$http
            .post(
              `/front/consumer/shoppingcart/checkCommodityPromotion`,
              shoppingCartFormList.map((item) => {
                return {
                  commodityId: item.goodsSkuId,
                  commodityNum: item.goodsNum
                }
              })
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                this.$confirm(res.message, this.$t('prompt.title'), {
                  confirmButtonText: this.$t('confirm'),
                  showCancelButton: false,
                  type: 'warning'
                }).then(() => {})
                return false
              } else {
                // if (!this.$store.state.user.defaultCompanyId) {
                //   // 非企业用户先升级才可下单
                //   this.$confirm(
                //     this.$t('navbar.storeSpare1'),
                //     this.$t('prompt.title'),
                //     {
                //       dangerouslyUseHTMLString: true,
                //       confirmButtonText: this.$t('navbar.upgrade'),
                //       cancelButtonText: this.$t('cancel')
                //     }
                //   ).then(() => {
                //     this.addCompanyVisible = true
                //     this.$nextTick(() => {
                //       this.$refs.companyAdd.init()
                //     })
                //   })
                //   return false
                // }
                this.$router.push({
                  name: 'createOrder',
                  query: {
                    orderSource: '10',
                    shoppingCartFormList: JSON.stringify(shoppingCartFormList)
                  }
                })
              }
            })
            .finally(() => {
              this.dataListLoading = false
            })
        }
      } else if (this.activited === '3') {
        this.$store.dispatch('setrequirementGoodsList', shoppingCartFormList)
        this.$router.push({
          name: 'spareRequirementsAdd',
          query: {
            getList: '1'
          }
        })
      } else if (this.activited === '4') {
        // 领用
        this.$store.dispatch('setLclbDataList', shoppingCartFormList)
        this.$router.push({
          name: 'spareGetAdd',
          query: {
            getList: 1
          }
        })
      } else if (this.activited === '6') {
        // 选型
        this.$router.push({
          name: 'selectionInquiryCreate',
          query: {
            shoppingCartFormList: JSON.stringify(shoppingCartFormList)
          }
        })
      }
    },
    // 筛选出一条属性
    filterAttribute (attrList) {
      if (attrList && attrList.length) {
        return `${attrList[0].attributeItemName}: ${attrList[0].attributeValueName}`
      }
      return ''
    }
  },
  filters: {
    isEmpty (val) {
      if (!val && val !== 0) {
        return '-'
      }
      return val
    }
  }
}
</script>
<style lang="scss" scoped>
.home_page {
  .tabs {
    margin: 0;
    border-bottom: 3px solid #0064c0;
    .s2b-tab-item {
      padding: 0 20px;
      color: #0064c0;
      background: none;
      height: 48px;
      line-height: 48px;
      margin-left: 0;
    }
    .tab-item-active {
      background: #0064c0;
      color: #fff;
    }
  }
  .right-menu-name {
    margin: 20px 0;
    padding: 0;
  }
  .shopping-cart {
    width: 100%;
    background: #fff;
    // padding: 15px 35px 30px;
    .discount {
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .goodsName {
      color: #1e64a9;
      cursor: pointer;
    }
    .fix {
      display: flex;
      height: 50px;
      background-color: #eeeeee;
      justify-content: space-between;
      .left {
        line-height: 50px;
        flex-shrink: 0;
        .check-all {
          margin-left: 15px;
          margin-right: 10px;
        }
        span {
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .div1 {
        margin-left: 220px;
        min-width: 140px;
        line-height: 50px;
        .red {
          font-weight: bold;
          color: red;
        }
      }
      .div2 {
        margin-left: 40px;
        min-width: 170px;
        .red {
          font-weight: bold;
          font-size: 15px;
          color: red;
        }
        .discount {
          text-decoration: line-through;
          color: #aaaaaa;
        }
      }
      .div3 {
        width: 141px;
        margin-left: 20px;
        color: #fff;
        background-color: #1e64a9;
        font-size: 18px;
      }
      .buttonDemand {
        margin-left: 200px;
      }
    }
  }
}
.detail {
  display: flex;
  position: relative;
  .goodsImg {
    margin-right: 12px;
    flex-shrink: 0;
    width: 60px;
    max-height: 60px;
  }
  .mask {
    background: #000;
    opacity: 0.7;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
  }
  .info {
    width: calc(100% - 72px);
    h3 {
      font-size: 14px;
      width: 100%;
      text-align: left;
      margin: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
    }
    span {
      text-align: left;
      display: block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
.fix-right {
  display: flex;
}
</style>
